export const LEARN_MORE = 'Select To Learn More';
export const AI_GENERATED = 'AI-generated from the text of customer reviews.';
export const CUSTOMERS_SAY = 'Customers Say';
export const WRITE_A_REVIEW_CTA = 'Write A Review';
